import Lenis from "lenis";

let lenis = null;
let rafId = null;

export function initLenis() {
    if (lenis) return lenis;
    lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return lenis;
}

export function destroyLenis() {
    if (rafId) cancelAnimationFrame(rafId);
    if (lenis) lenis.destroy();
    lenis = null;
    rafId = null;
}

export function scrollToTop() {
    if (lenis) {
        lenis.scrollTo(0, { immediate: true });
    } else {
        window.scrollTo(0, 0);
    }
}
